export const baseEvent = {
  context: 'PAYMENT',
} as const

export const BaseEventTypes = {
  CREATED: 'CREATED',
  DELETED: 'DELETED',
  UPDATED: 'UPDATED',
} as const
